import React from 'react';
import './loadingBar.css';

const NoDataAvailable = () => {
  return (
    <div className="loading-container">
      <div className="loading-track">
        {[...Array(10)].map((_, index) => (
          <div key={index} className="loading-item">
            <span className="loading-text"> No data available </span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default NoDataAvailable;
